import { Component } from '@angular/core';

@Component({
  selector: 'conpulse-web-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'authentication';
}
